export default {
      id: "Icon--refresh-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "sprite.svg#Icon--refresh",
      toString: function () {
        return this.url;
      }
    }